// extracted by mini-css-extract-plugin
export var container = "graphicsMobile-module--container--2tgAU";
export var dashboard = "graphicsMobile-module--dashboard--3-9Yq";
export var dashboard_lightbulb = "graphicsMobile-module--dashboard_lightbulb--2FO70";
export var light = "graphicsMobile-module--light--3WrhT";
export var jsAnimInit = "graphicsMobile-module--jsAnimInit--3GoX8";